import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.currentPOId = null
    this.clearMessages()
  }

  async handleScan(event) {
    event.preventDefault()
    const scanInput = event.target
    const barcode = scanInput.value.trim()

    if (!barcode) return

    // Clear input for next scan
    scanInput.value = ''

    // Hide previous messages
    this.clearMessages()

    try {
      const response = await fetch('/receiving_station/scan', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({
          scan_input: barcode,
          current_po_id: this.currentPOId
        })
      })

      const data = await response.json()

      if (response.ok) {
        if (data.type === 'purchase_order') {
          this.displayPurchaseOrder(data.purchase_order)
          this.currentPOId = data.purchase_order.id
        } else if (data.type === 'item_received') {
          this.showSuccess(data.message)
          this.updateLineItem(data.line_item)

          // If all items received, show completion message
          if (data.all_items_received) {
            setTimeout(() => {
              this.showSuccess('All items received! PO marked as complete.')
              // Optionally clear display after a delay
              setTimeout(() => this.clearDisplay(), 3000)
            }, 2000)
          }
        }
      } else {
        this.showError(data.error || 'Unknown error occurred')
      }
    } catch (error) {
      this.showError('Network error: ' + error.message)
    }

    // Refocus on scan input
    scanInput.focus()
  }

  displayPurchaseOrder(po) {
    // Update PO header
    document.getElementById('po-number').textContent = `PO #${po.po_number}`
    document.getElementById('po-vendor').textContent = `Vendor: ${po.vendor}`

    // Update status badge
    const statusBadge = document.getElementById('po-status')
    statusBadge.textContent = po.status
    statusBadge.className = `px-3 py-1 text-sm font-semibold rounded-full ${this.getStatusClass(po.status)}`

    // Populate line items table
    const tbody = document.getElementById('line-items-body')
    tbody.innerHTML = ''

    po.line_items.forEach(item => {
      const row = this.createLineItemRow(item)
      tbody.appendChild(row)
    })

    // Show PO display
    document.getElementById('po-display').classList.remove('hidden')
  }

  createLineItemRow(item) {
    const row = document.createElement('tr')
    row.id = `line-item-${item.id}`
    row.className = item.received ? 'bg-green-50' : ''

    row.innerHTML = `
      <td class="px-4 py-2 text-sm font-medium text-gray-900">${item.sku}</td>
      <td class="px-4 py-2 text-sm text-gray-900">${item.product_name}</td>
      <td class="px-4 py-2 text-sm text-right text-gray-900">${item.quantity_ordered}</td>
      <td class="px-4 py-2 text-sm text-right text-gray-900">${item.quantity_received}</td>
      <td class="px-4 py-2 text-sm text-right ${item.quantity_remaining > 0 ? 'text-orange-600 font-semibold' : 'text-green-600'}">${item.quantity_remaining}</td>
      <td class="px-4 py-2 text-sm text-center">
        <span class="px-2 py-1 text-xs font-semibold rounded-full ${item.received ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}">
          ${item.received ? 'Received' : 'Pending'}
        </span>
      </td>
    `

    return row
  }

  updateLineItem(item) {
    const row = document.getElementById(`line-item-${item.id}`)
    if (row) {
      // Update quantities
      row.cells[3].textContent = item.quantity_received
      row.cells[4].textContent = item.quantity_remaining
      row.cells[4].className = item.quantity_remaining > 0
        ? 'px-4 py-2 text-sm text-right text-orange-600 font-semibold'
        : 'px-4 py-2 text-sm text-right text-green-600'

      // Update status
      if (item.received) {
        row.className = 'bg-green-50'
        row.cells[5].innerHTML = `
          <span class="px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
            Received
          </span>
        `
      }
    }
  }

  getStatusClass(status) {
    switch(status) {
      case 'Draft': return 'bg-gray-100 text-gray-800'
      case 'Ordered': return 'bg-blue-100 text-blue-800'
      case 'In Transit': return 'bg-yellow-100 text-yellow-800'
      case 'Received': return 'bg-green-100 text-green-800'
      case 'Cancelled': return 'bg-red-100 text-red-800'
      default: return 'bg-gray-100 text-gray-800'
    }
  }

  showSuccess(message) {
    const successDiv = document.getElementById('success-message')
    document.getElementById('success-text').textContent = message
    successDiv.classList.remove('hidden')

    setTimeout(() => {
      successDiv.classList.add('hidden')
    }, 5000)
  }

  showError(message) {
    const errorDiv = document.getElementById('error-message')
    document.getElementById('error-text').textContent = message
    errorDiv.classList.remove('hidden')

    setTimeout(() => {
      errorDiv.classList.add('hidden')
    }, 5000)
  }

  clearMessages() {
    document.getElementById('success-message').classList.add('hidden')
    document.getElementById('error-message').classList.add('hidden')
  }

  clearDisplay() {
    document.getElementById('po-display').classList.add('hidden')
    this.currentPOId = null
    this.clearMessages()
  }
}
